export enum FactoryAssetType{
    Laser = 'Laser',
    PressBrake = 'Press Brake',
    RollFormer = 'Roll Former',
    PlasticMachine = 'Plastic Machine',
    InjectionMoldingMachine = 'Injection Molding Machine',
    PunchPress = 'Punch Press',
    ForkLift = 'ForkLift',
    Other = 'Other',
    Robot = 'Robot',
    GolfCart = 'Golf Cart',
}